<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h630_dialog abow_dialog"
      width="1200px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="省区">
                  <el-input
                    v-model="dialogViewForm.provinceName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="城市">
                  <el-input
                    v-model="dialogViewForm.cityName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="方案名称">
                  <el-input
                    v-model="dialogViewForm.schemeName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="方案编号">
                  <el-input
                    v-model="dialogViewForm.schemeNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="活动名称">
                  <el-input
                    v-model="dialogViewForm.activityName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="活动日期">
                  <el-input
                    v-model="dialogViewForm.activityDate"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="活动场所">
                  <el-input
                    v-model="dialogViewForm.storeNames"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="人员名称">
                  <el-input
                    v-model="dialogViewForm.userName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="问题生成时间">
                  <el-input
                    v-model="dialogViewForm.warningTime"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="问题内容">
                  <el-input
                    v-model="dialogViewForm.warningInfo"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              v-if="dialogViewForm.isAuditInfo === 1"
              :gutter="10"
            >
              <el-col :span="6">
                <el-form-item label="是否审核生成">
                  <el-input
                    v-model="dialogViewForm.isAuditInfoValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="审核人">
                  <el-input
                    v-model="dialogViewForm.auditorName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="审核结果">
                  <el-input
                    v-model="dialogViewForm.auditResultValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="处理方式"
                  prop="processStatus"
                >
                  <el-radio-group
                    v-model="dialogAddEditViewForm.processStatus"
                  >
                    <el-radio :label="2">
                      忽略
                    </el-radio>
                    <el-radio :label="3">
                      据实
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item
                  label="处理说明"
                  prop="processInfo"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.processInfo"
                    type="textarea"
                    maxlength="256"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditViewForm.remark"
                    type="textarea"
                    maxlength="512"
                    placeholder="备注"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 终端恢复申请API
import { viewActivityWarningInfoListApi, updateActivityWarningInfoListProcessApi } from '@/api/v2/activityWarningInfoList';

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogViewForm:{},
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        processStatus: [{ required: true, message: '请选择处理方式', trigger: 'change' }],
        processInfo: [{ required: true, message: '请输入处理说明', trigger: 'blur' },{ max: 256, message: '最多输入256个字符', trigger: 'blur' }],
        remark: [{ max: 512, message: '最多输入512个字符', trigger: 'blur' }]
      }
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.dialogViewForm = {}
        _this.dialogAddEditViewForm = {
          processStatus: 3,
          processInfo: '',
          remark: ''
        }
        _this.loadActivityWarningInfoListData();

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    },
  },
  methods: {
    // 加载终端恢复申请数据
    loadActivityWarningInfoListData () {
      let _this = this;
      viewActivityWarningInfoListApi({ id: _this.dataId }).then((response) => {
        const { data } = response;
        _this.dialogViewForm = data;
        _this.dialogAddEditViewForm.remark = data.remark;
        _this.dialogAddEditViewForm.id = data.id;
      })
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false);
      _this.$refs.dialogAddEditViewForm.clearValidate();
    },
    // 新增|修改保存
    handleSave () {
      let _this = this;
      _this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          _this.$confirm('是否确定保存该质量问题处理信息', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            updateActivityWarningInfoListProcessApi(_this.dialogAddEditViewForm).then(() => {
              _this.$message({ message: '保存成功', type: 'success' })
              _this.$emit('reloadData')
              _this.modalClose()
            }).catch(() => { })
          }).catch(() => { })
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.explain-tooltip {
  float: right;
  margin-top: 10px;
  margin-right: 15px;
  color: white;
  cursor: pointer;
}
</style>
